import { render, staticRenderFns } from "./CompliantStatement.vue?vue&type=template&id=619c4a90&"
import script from "./CompliantStatement.vue?vue&type=script&lang=js&"
export * from "./CompliantStatement.vue?vue&type=script&lang=js&"
import style0 from "./CompliantStatement.vue?vue&type=style&index=0&id=619c4a90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports